import React from "react";
import Card from "./Card";

import styles from "./ChannelCard.module.scss";

interface ChannelCardProps {
  icon: string;
}

const ChannelCard = ({ icon }: ChannelCardProps) => {
  return (
    <Card className={styles.card}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img alt="" src={icon} className={styles.icon} />
    </Card>
  );
};

export default ChannelCard;
